'use client';
import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';

// 定義 DimContext 的類型
interface DimContextType {
    isDimmed: boolean;
    acquire: () => void; // ++counter
    release: () => void; // --counter
}
// 創建 Context
const DimContext = createContext<DimContextType | undefined>(undefined);

// 提供者組件的屬性類型
interface DimProviderProps {
    children: ReactNode;
}

export const DimProvider: React.FC<DimProviderProps> = ({ children }) => {
    const [count, setCount] = useState(0);

    const acquire = () => setCount((c) => c + 1);
    const release = () => setCount((c) => Math.max(0, c - 1));

    const value = useMemo(() => ({ isDimmed: count > 0, acquire, release }), [count]);

    return <DimContext.Provider value={value}>{children}</DimContext.Provider>;
};

export const useDim = (): DimContextType => {
    const context = useContext(DimContext);
    if (context === undefined) {
        throw new Error('useDim must be used within a DimProvider');
    }
    return context;
};
